import type { Catalogue } from './types';

/**
 * Adresse du catalogue.
 *
 * Il est publié sur le stockage objet à chaque modification faite dans
 * l'administration. Le site public ne touche donc jamais le VPS : il lit un JSON et
 * des fichiers, servis par le CDN. Une panne du serveur — comme celle du
 * 10 septembre — laisse le site en ligne.
 */
const URL_CATALOGUE =
  (import.meta.env.VITE_CATALOGUE_URL as string | undefined) ??
  // En production, le site est servi à côté du catalogue par le CDN : un chemin
  // relatif suffit. En développement, il n'y a pas de CDN — le catalogue vient de
  // l'API, à travers le proxy de vite.
  (import.meta.env.DEV ? '/api/catalogue.json' : '/catalogue.json');

export async function chargerCatalogue(signal?: AbortSignal): Promise<Catalogue> {
  const reponse = await fetch(URL_CATALOGUE, { signal });
  if (!reponse.ok) {
    throw new Error(`Catalogue indisponible (HTTP ${reponse.status})`);
  }
  return (await reponse.json()) as Catalogue;
}

/** Fabrique un fragment d'URL lisible à partir d'un libellé de rubrique. */
export function versSlug(libelle: string): string {
  return libelle
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}
